import { c as _c } from "react/compiler-runtime";
import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../../store/provider';
import { useSkillsSuggestions } from '../../store/suggestions';
import type { Suggestion } from '../../store/types';
import PatchCard from './primitives/patch-card';
import ProseDiff from './primitives/prose-diff';
type FileEntry = {
  path: string;
  content: string;
};
const flattenSkills = (nodes: SkillFileNode[], prefix = ''): FileEntry[] => {
  return nodes.flatMap(node => {
    const path = prefix ? `${prefix}/${node.name}` : node.name;
    if (node.kind === 'folder') return flattenSkills(node.children, path);
    return [{
      path,
      content: node.content
    }];
  });
};
const SkillsSuggestions = () => {
  const $ = _c(4);
  const suggestions = useSkillsSuggestions();
  if (suggestions.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== suggestions) {
    t0 = suggestions.map(_temp);
    $[0] = suggestions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex flex-col gap-3">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
type Props = {
  suggestion: Suggestion;
};
const SkillsPatchCard = t0 => {
  const $ = _c(35);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.skills"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    state
  } = useBuilder();
  const op = suggestion.operation;
  if (op.kind !== "update_skills") {
    return null;
  }
  let T0;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== op.skills || $[2] !== state.bundle.skills || $[3] !== suggestion.canApply || $[4] !== suggestion.id || $[5] !== t) {
    const currentFiles = flattenSkills(state.bundle.skills);
    const nextFiles = flattenSkills(op.skills);
    const currentByPath = new Map(currentFiles.map(_temp2));
    const nextByPath = new Map(nextFiles.map(_temp3));
    const added = nextFiles.filter(f_1 => !currentByPath.has(f_1.path));
    const removed = currentFiles.filter(f_2 => !nextByPath.has(f_2.path));
    const changed = nextFiles.filter(f_3 => {
      const prev = currentByPath.get(f_3.path);
      return prev !== undefined && prev !== f_3.content;
    });
    T0 = PatchCard;
    t6 = suggestion.id;
    if ($[16] !== t) {
      t7 = t(_temp4);
      $[16] = t;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t8 = !suggestion.canApply;
    if ($[18] !== t) {
      t9 = t(_temp5);
      $[18] = t;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    t10 = changed.length > 0;
    t2 = "flex flex-col gap-2";
    t3 = added.map(_temp6);
    t4 = removed.map(_temp7);
    let t11;
    if ($[20] !== currentByPath) {
      t11 = f_6 => <div key={f_6.path} className="flex flex-col gap-1"><span className="text-caption-3 text-tertiary font-mono!">{f_6.path}</span><ProseDiff current={currentByPath.get(f_6.path) ?? ""} suggested={f_6.content} /></div>;
      $[20] = currentByPath;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t5 = changed.map(t11);
    $[1] = op.skills;
    $[2] = state.bundle.skills;
    $[3] = suggestion.canApply;
    $[4] = suggestion.id;
    $[5] = t;
    $[6] = T0;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t11 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== T0 || $[28] !== t10 || $[29] !== t11 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t12 = <T0 suggestionId={t6} note={t7} isStale={t8} title={t9} showDiffToggle={t10}>{t11}</T0>;
    $[27] = T0;
    $[28] = t10;
    $[29] = t11;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export default SkillsSuggestions;
function _temp(s) {
  return <SkillsPatchCard key={s.id} suggestion={s} />;
}
function _temp2(f) {
  return [f.path, f.content];
}
function _temp3(f_0) {
  return [f_0.path, f_0.content];
}
function _temp4($) {
  return $.refined;
}
function _temp5($_0) {
  return $_0.title;
}
function _temp6(f_4) {
  return <div key={f_4.path} className="text-caption-3 text-success font-mono!">+ {f_4.path}</div>;
}
function _temp7(f_5) {
  return <div key={f_5.path} className="text-caption-3 text-error line-through decoration-error/60 font-mono!">- {f_5.path}</div>;
}